import { render } from "./BalanceRulesTable.vue?vue&type=template&id=ccb90c72&scoped=true"
import script from "./BalanceRulesTable.vue?vue&type=script&lang=js"
export * from "./BalanceRulesTable.vue?vue&type=script&lang=js"

import "./BalanceRulesTable.vue?vue&type=style&index=0&id=ccb90c72&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccb90c72"]])

export default __exports__